import { isEmpty } from 'lodash-es';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ScheduleRequestListItem } from '../types';
import { usePartnerScheduleRequestsAccess } from './use-partner-schedule-requests-access';
import { useScheduleRequestFeaturesAccess } from './use-schedule-request-features-access';

export type ScheduleRequestSource = 'AI' | 'partner' | 'online_scheduling';

export const useScheduleRequestType = (listItem: ScheduleRequestListItem) => {
  const { hasAirScheduleRequestAccess } = useScheduleRequestFeaturesAccess();
  const { hasPartnerScheduleRequestsAccess } = usePartnerScheduleRequestsAccess(listItem.locationId);
  const isAiRequest = hasAirScheduleRequestAccess && !isEmpty(listItem.aiRequestDetails);
  const isPartnerRequest = hasPartnerScheduleRequestsAccess && listItem.attribution?.platform === 'PARTNER';
  const isUrgentRequest =
    (isAiRequest && listItem.aiRequestDetails?.visitDetails?.priority === 'urgent') ||
    (isPartnerRequest && listItem?.priority === 'URGENT');

  const isPreferenceBasedRequest = isPartnerRequest || isAiRequest;

  const requestVersion = listItem.linkHash || '';

  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const isV3Request = requestVersion !== 'v2' && isScheduleV3FlagEnabled;
  const isV2Request = !isV3Request;

  // NOTE: We can't rely on `attribution.platform` alone to determine the request source, as non-partner requests may not have a platform specified.
  const requestSource: ScheduleRequestSource = isPartnerRequest
    ? 'partner'
    : listItem.aiRequestDetails
    ? 'AI'
    : 'online_scheduling';

  return {
    isAiRequest,
    isPartnerRequest,
    isUrgentRequest,
    requestSource,
    isPreferenceBasedRequest,
    isV3Request,
    isV2Request,
  };
};
